<template>
  <div :class="'alert d-flex align-items-center w-100 alert alert-light-' + type + ' ' + width">
    <FontAwesomeIcon v-if="icon" :icon="'fa-light fa-' + icon" />
    <div :class="{ 'ms-2': !!icon }">
      <div class="fw-bold" v-if="title">{{ title }}</div>
      <div class="mb-0" v-html="text"></div>
    </div>
    <div v-if="actions && actions.length">
      <button
        v-for="action in actions"
        :key="action.action"
        v-tooltip="{ title: action.tooltip }"
        :class="'ms-2 me-0 btn btn-icon -' + type"
        @click="handleClick(action)"
      >
        <FontAwesomeIcon :icon="'fa-light fa-' + action.icon" />
      </button>
    </div>
    <router-link
      v-if="alertLink && Object.keys(alertLink).length"
      :to="{ name: alertLink.name, params: { alias: alertLink.alias } }"
      @click="cancel"
      >{{ alertLink.text }}</router-link
    >
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "AlertBlock",
  emits: ["cancel"],
  components: { FontAwesomeIcon },
  props: {
    type: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    actions: {
      type: Object,
      required: false,
      default: null,
    },
    alertLink: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    handleClick(action) {
      this.$emit(action.action);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  width: fit-content;

  &__icon {
    font-size: 16px;
    margin-right: 4px;
  }
}

.btn-icon {
  &.-warning {
    color: #f8a007;
  }
  &.-danger {
    color: #da5164;
  }
  &.-success {
    color: #6ac7a4;
  }

  svg {
    height: 1em;
  }
}
</style>
